import type React from 'react';

export interface SuccessCheckProps {
	width?: string | number;
	height?: string | number;
	fill?: string;
	'aria-label'?: string;
}

const SuccessCheck: React.FC<SuccessCheckProps> = ({
	width = 55,
	height = 56,
	fill,
	'aria-label': ariaLabel = 'Success Check',
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 55 56"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-label={ariaLabel}
		>
			<title>Success Check Icon</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 28.4332C0 21.1398 2.89731 14.145 8.05456 8.98779C13.2118 3.83054 20.2065 0.933228 27.5 0.933228C34.7935 0.933228 41.7882 3.83054 46.9454 8.98779C52.1027 14.145 55 21.1398 55 28.4332C55 35.7267 52.1027 42.7214 46.9454 47.8787C41.7882 53.0359 34.7935 55.9332 27.5 55.9332C20.2065 55.9332 13.2118 53.0359 8.05456 47.8787C2.89731 42.7214 0 35.7267 0 28.4332ZM25.9307 40.2032L41.7633 20.4106L38.9033 18.1226L25.4027 34.9929L15.84 27.0252L13.4933 29.8412L25.9307 40.2032Z"
				fill={fill ? fill : 'url(#paint0_linear_3166_11047)'}
			/>
			<defs>
				<linearGradient
					id={'paint0_linear_3166_11047'}
					x1="27.5"
					y1="0.933228"
					x2="27.5"
					y2="55.9332"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#1C4B74" />
					<stop offset="1" stopColor="#117964" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SuccessCheck;